import { render, staticRenderFns } from "./AlertStickyBar.vue?vue&type=template&id=b492f642&scoped=true"
import script from "./AlertStickyBar.vue?vue&type=script&lang=js"
export * from "./AlertStickyBar.vue?vue&type=script&lang=js"
import style0 from "./AlertStickyBar.vue?vue&type=style&index=0&id=b492f642&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b492f642",
  null
  
)

export default component.exports